import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectPagesLegacyRoute: InvariantJiraRoute = {
	name: 'project-pages-legacy',
	path: '/projects/:projectKey',
	query: ['selectedItem=com.atlassian.jira.jira-projects-plugin:project-pages-page'],
};
